import { RolesMap } from '@/models/user'
import { RouteRecordRaw } from 'vue-router'
import ProposalModule from './ProposalModule.vue'
import ShowProposal from './views/ShowProposal.vue'
import CreateProposal from './views/CreateProposal.vue'
import CustomerViewProposal from './views/CustomerViewProposal.vue'
import CreateChangeOrder from './views/CreateChangeOrder.vue'
import ListProposals from './views/ListProposals.vue'
import EditProposal from './views/EditProposal.vue'
import CustomerViewChangeOrder from './views/CustomerViewChangeOrder.vue'
import EditChangeOrder from './views/EditChangeOrder.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/proposals',
    component: ProposalModule,
    meta: { authorize: [RolesMap.EMPLOYEE_ROLE] },
    children: [
      {
        path: '',
        name: 'ListProposals',
        component: ListProposals,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: ':id',
        name: 'ShowProposal',
        component: ShowProposal,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: ':id/new',
        name: 'CreateProposal',
        component: CreateProposal,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'edit/:id',
        name: 'EditProposal',
        component: EditProposal,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: '/changeOrders/:id/new',
        name: 'CreateChangeOrder',
        component: CreateChangeOrder,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: ':proposalId/changeOrders/edit/:id',
        name: 'EditChangeOrder',
        component: EditChangeOrder,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      }
    ]
  },
  {
    path: '/proposal/:id',
    name: 'CustomerViewProposal',
    component: CustomerViewProposal
  },
  {
    path: '/changeOrder/:id/:proposalId',
    name: 'CustomerViewChangeOrder',
    component: CustomerViewChangeOrder
  }
]

export default routes
